// Shared architectural dimensions for the live Hall and its project illustration.
// The caller supplies the box builder and materials, so this module has no renderer.
export function buildMuseumPavilion(box, { edge, floor, stone, paper, metal }) {
  box(29,.18,30,edge,0,-.32,1.1);
  box(27.4,.19,28,floor,0,-.135,.6);
  box(27,.035,27,floor,0,-.023,0);
  for(let i=0;i<3;i++)box(9+i*.9,.07,1.1,floor,0,-.10-i*.08,14.1+i*.95);
  // Low gallery wings give the pavilion an architectural depth beyond its foyer.
  box(29,.3,21,edge,0,-.21,-23.8);
  for(const x of [-8,8]){box(11,5.2,18,stone,x,2.6,-24);box(11.7,.24,18.7,paper,x,5.32,-24);box(7.4,.16,1.6,metal,x,5.49,-24);}
  box(5,4.65,17,stone,0,2.32,-23);box(5.7,.2,17.4,paper,0,4.76,-23);
  // One broad canopy and an open clerestory replace repetitive ceiling bars.
  box(28,.24,9,stone,0,6.4,-8.5);box(28,.24,8.3,stone,0,6.4,8.1);
  box(27.6,.055,8.7,edge,0,6.245,-8.5);box(27.6,.055,8,edge,0,6.245,8.1);
  box(5,.32,8.8,stone,-11.5,6.4,-.3);box(5,.32,8.8,stone,11.5,6.4,-.3);
  box(18,.12,.16,metal,0,6.18,4);box(18,.12,.16,metal,0,6.18,-4);
  for(const x of [-11.5,11.5])for(const z of [-9,-3.3,2.35,8])box(.22,6.24,.42,stone,x,3.12,z);
  // Deep openings and a continuous thin reveal give the pale masonry depth.
  box(.35,3.8,8.5,stone,-12,1.9,-7);box(.35,3.8,6.3,stone,12,1.9,-8);
  box(7.9,5.6,.38,stone,-8,2.8,-10);box(7.9,5.6,.38,stone,8,2.8,-10);
  box(8.2,.8,.6,stone,0,5.6,-10);box(.42,5.2,4.7,stone,-4.15,2.6,-12.1);box(.42,5.2,4.7,stone,4.15,2.6,-12.1);
  box(8.4,5.6,.3,edge,0,2.8,-14.4);box(8,.08,4.5,floor,0,.015,-12.1);
  // The archive occupies a lower reading court beside the entrance hall.
  // A continuous floor and open western edge keep both spaces connected.
  box(9.1,.18,24.8,edge,19.05,-.32,3.7);
  box(9.25,.19,23.2,floor,18.325,-.135,3.7);
  box(9.3,.035,22.1,floor,18.15,-.023,3.05);
  box(.38,5.35,19,stone,22.55,2.675,2);
  box(9.3,5.35,.36,stone,18,2.675,-7.3);
  // Four roof planes frame a sky opening directly over the map table.
  box(11.5,.22,5.5,stone,17.45,5.45,-4.65);
  box(11.5,.22,3.5,stone,17.45,5.45,10.85);
  box(2.3,.22,11.5,stone,12.85,5.45,3.85);
  box(3.7,.22,11.5,stone,21.3,5.45,3.85);
  for(const x of [14.05,19.35])box(.055,.12,11.5,metal,x,5.27,3.85);
  for(const z of [-1.9,9.6])box(5.35,.12,.055,metal,16.7,5.27,z);
  for(const x of [13.3,21.8])box(.2,5.3,.35,stone,x,2.65,11.4);
  // A low bench gives the small room human scale.
  box(1.05,.15,7.4,paper,21.4,.62,2.8);
  for(const z of [-.2,5.8])box(.7,.48,.24,stone,21.4,.31,z);
  box(9.7,.07,.8,floor,18.25,-.1,14.5);
  box(10.1,.07,.7,floor,18.45,-.18,15.15);
}
